import React from 'react'
import PropTypes from 'prop-types'
import withTheme from '@material-ui/core/styles/withTheme'
import pure from 'recompose/pure'
import FaPinterest from 'react-icons/lib/fa/pinterest-p'
import FaFacebook from 'react-icons/lib/fa/facebook'
import FaInstagram from 'react-icons/lib/io/social-instagram-outline'
import FaGooglePlus from 'react-icons/lib/fa/google-plus'
import FaTwitter from 'react-icons/lib/fa/twitter'
import startCase from 'lodash/startCase'

const FollowBar = ({ theme, dark }) => {
  const socialMediaLinks = [
    {
      type: 'pinterest',
      url: process.env.PINTEREST_URL,
      color: theme.palette.social.pinterest,
      Icon: FaPinterest,
    },
    {
      type: 'facebook',
      url: process.env.FACEBOOK_PAGE,
      color: theme.palette.social.facebook,
      Icon: FaFacebook,
    },
    {
      type: 'twitter',
      url: process.env.TWITTER_URL,
      color: theme.palette.social.twitter,
      Icon: FaTwitter,
    },
    {
      type: 'instagram',
      url: process.env.INSTAGRAM_URL,
      color: theme.palette.social.instagram,
      Icon: FaInstagram,
    },
    {
      type: 'google plus',
      url: process.env.GOOGLEPLUS_URL,
      color: theme.palette.social.googleplus,
      Icon: FaGooglePlus,
    },
  ]

  return socialMediaLinks.map(({ type, url, color, Icon }) => (
    <a
      key={url}
      href={url}
      target="_blank"
      style={{ margin: '0 2px', cursor: 'pointer' }}
      title={startCase(type)}
    >
      <Icon
        style={{
          color: dark ? '#fff' : color,
          borderRadius: '50%',
          background: dark ? color : '#fff',
          padding: 4,
          opacity: 0.9,
          fontSize: '1.55em',
        }}
      />
      <style>{`
        span:hover {
          opacity: 0.7;
        }
        `}</style>
    </a>
  ))
}

FollowBar.propTypes = {
  theme: PropTypes.object.isRequired,
}

export default withTheme()(pure(FollowBar))



// WEBPACK FOOTER //
// ./src/components/Navigation/FollowBar.js